import React, {useEffect, useState} from 'react';
import {format} from "date-fns";
import {updateGDPR} from "../data/data-service";
import {sendGAEvent} from "../../../domain/marketing/gtm-provider";
import { IGdpr, setGDPRCookie } from '../domain/gdpr-provider';


const GDPRWidget = () => {
    const [isAgreed, setAgreed] = useState(false);
    const emailDiv = document.getElementById('waves-user-email');
    const gdprCountryDiv = document.getElementById('gdpr-country');
    const isGdprCountry = gdprCountryDiv && gdprCountryDiv.textContent !== '' ? gdprCountryDiv.textContent : 'u';
    const isUserLoggedIn = emailDiv && emailDiv.textContent !== '' ;

    useEffect(() => {
        setTimeout( () => {
            const slideUp = document.getElementById('slide-up');
            if(slideUp)
                slideUp.classList.remove('close');
        },500);

    }, []);
    /**
     * send data to google analytics
     * https://jira.waves.com:8443/browse/WAV-664
     * @param {string} gaValue
     * @param {string} gaAction
     */
    const sendDataToGA = (gaValue:string, gaAction:string) => {
        sendGAEvent(gaAction,gaValue);
    }

    /**
     * on read more click
     */
    const handleReadMoreClick = () => {
        sendDataToGA('Read More','Consent Widget');
    }

    /***
     * @param {string} gaValue
     * I agree button is clicked
     **/
    const agreeClicked = async( gaValue = '') => {
        /*evt.preventDefault();*/
        const data: IGdpr = {
            IsMarketing: true,
            IsPerformance: true,
            ItemModifiedWhen: format(new Date(),'MM/dd/yyyy HH:mm:ss'),
            IsCountryGDPR: isGdprCountry || ''
            //ItemModifiedWhen: this.state.gdprMacro ? this.state.gdprMacro.ItemModifiedWhen : Date.now().toString('MM/dd/yyyy HH:mm:ss')
        };
        if (!isUserLoggedIn){
            setGDPRCookie(data);
        }
        if (isUserLoggedIn) {
            //update database per cookie - /2code/handlers/gdpr.ashx
            setGDPRCookie(data);
            await updateGDPR();
        }
        setAgreed(true);
        sendDataToGA(gaValue,'Consent Widget');
    }
    return(
            <div>

                {/* BOTTOM-RIGHT-CORNER-----------------------------------------------------------------------------------------------------------*/}
                {!isAgreed && (
                    <div id="slide-up" className={'w-full fixed bottom-0 bottom-right-corner slide-up close'} style={{zIndex:'199'}}>


                        <div className="flex flex-col items-center justify-center text-center w-full py-6" style={{backgroundColor:'#EFFF00', color:'#16151C'}}>
                            <div className="img-cookies w-32 md:pb-6">
                                <img src="https://media.wavescdn.com/images//design/cookies/cookie-black.svg" alt="cookies" />
                            </div>
                            <p className="text-3xl font-bold">Life is sweeter <br /> with cookies...</p>
                            <p className="font-white pt-4 md:pt-2">
                                We use{' '}
                                <a style={{color:'#16151C'}}
                                   className="font-bold"
                                   href="/legal/cookie-policy"
                                   title=""
                                   onClick={handleReadMoreClick}
                                > cookies
                                </a> to give the best <br /> possible experience when using our website
                            </p>

                            <button
                                className="w-btn bg-gray-700 text-white w-32 mt-4 mb-10 md:mb-0"
                                onClick={async () => {
                                    await agreeClicked('I Agree');
                                }}>OK</button>

                            <button
                                className="blue-button dismiss-btn flex justify-center absolute-right-top bg-gray-700 rounded-full mr-2 mt-2 md:mr-6 md:mt-6 p-3"
                                onClick={async() => {
                                    await agreeClicked('Dismiss');
                                }}>
                                <svg className="" width="18" height="18" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg"><title>Close</title><path d="M1.406 0L0 1.406l6.375 6.375L0 14.156l1.406 1.406 6.375-6.375 6.375 6.375 1.406-1.406-6.375-6.375 6.375-6.375L14.156 0 7.781 6.375z" fill="#FFFFFF" stroke="none" strokeWidth="2" fillRule="evenodd" /></svg>
                                <span></span>
                            </button>

                        </div>
                    </div>
                )}
            </div>
        );
}

export default GDPRWidget;